import { createContext, ReactNode, useContext, useState } from 'react';
import { PutApiProjectsByIdDeliverableTypesApiArg } from '../../../../../app/athenaApiGen';
import { EMPTY_PAYLOAD } from './const';

type TProjectTypesContext = {
  addTypeModal: boolean;
  setAddTypeModal: React.Dispatch<React.SetStateAction<boolean>>;
  payload: PutApiProjectsByIdDeliverableTypesApiArg;
  setPayload: React.Dispatch<
    React.SetStateAction<PutApiProjectsByIdDeliverableTypesApiArg>
  >;
  projectDelTypeIds: string[];
  setProjectDelTypeIds: React.Dispatch<React.SetStateAction<string[]>>;
};

const ProjectTypesContext = createContext<TProjectTypesContext | undefined>(
  undefined,
);

const ProjectTypesProviders: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [addTypeModal, setAddTypeModal] = useState<boolean>(false);
  const [payload, setPayload] =
    useState<PutApiProjectsByIdDeliverableTypesApiArg>(EMPTY_PAYLOAD);
  const [projectDelTypeIds, setProjectDelTypeIds] = useState<string[]>([]);

  const contextValue = {
    addTypeModal,
    setAddTypeModal,
    payload,
    setPayload,
    projectDelTypeIds,
    setProjectDelTypeIds,
  };

  return (
    <ProjectTypesContext.Provider value={contextValue}>
      {children}
    </ProjectTypesContext.Provider>
  );
};

const useProjectTypeContext = () => {
  const context = useContext(ProjectTypesContext);
  if (context === undefined) {
    throw new Error(
      'useProjectTypeContext must be used within a ProjectTypesProvider',
    );
  }
  return context;
};

export { ProjectTypesProviders, useProjectTypeContext };
